import { IBlueBenefitsSubscription } from "../../../../../blue-benefits/models/subscriptions/blue-benefits-subscription.interface";
import { DialogResult } from "../../../../../dialog/dialog-enums";
import { IDotRezPersonComment } from "../../../../../dot-rez-api/data-contracts/user/person.data-contracts";
import {IServiceFactory} from "../../../../../service-factory.interface";
import {CompanionModel} from "../../../companion/companion.model";
import {IPersonViewModel} from "../../../person/person-view-model.interface";
import {AuthorizedUserProfileModel} from "../authorized-user-profile.model";
import {IAuthorizedUserProfileDomain} from "./authorized-user-profile-domain.interface";
import {Price} from "../../../../../currency/price";
import {NullableNumber} from "../../../../../../types/nullable-types";

export class B2cAuthorizedUserProfileDomainModel implements IAuthorizedUserProfileDomain {
    constructor(private readonly userProfile: AuthorizedUserProfileModel) {
    }

    readonly organizationCredit: Price | null = null;
    readonly allowHoldBooking: boolean = false;

    private get services(): IServiceFactory {
        return this.userProfile.services;
    }
    get canAddCompanions(): boolean {
        return this.userProfile.companions.length < this.services.configuration.data.maxAllowedPassengersNumberOnBooking;
    }
    async readCompanions(): Promise<CompanionModel[]> {
        try {
            const session = await this.userProfile.getSession();
            const companionsData = await this.services.airlineWebapi.getCompanions(session.token)
            return companionsData.map(data => new CompanionModel(this.userProfile, data));
        } catch (err) {
            this.services.logger.error('Failed to load user companions', err);
            return []
        }
    }
    async getBlueBenefitsSubscriptions(personComments: IDotRezPersonComment[]): Promise<IBlueBenefitsSubscription[]> {
        const subscriptions = await this.services.blueBenefits.createSubscriptionsFromPersonComments(personComments || []);

        return subscriptions.sort((s1, s2) => s2.expirationDate.getTime() - s1.expirationDate.getTime());
    }

    getCompanionsForBooking(): IPersonViewModel[] {
        return [
            this.userProfile.asCompanion(),
            ...this.userProfile.companions
        ];
    }

    async showContactInformationEditor(): Promise<DialogResult> {
        return await this.services.dialogFactory.showB2CAuthorizedUserContactInformationEditor(this.userProfile);
    }

    get shouldLoadBookingHistoryOnStartup(): boolean {
        return true; //basically only for hybrid is allowed
    }

    async updateOrganizationInfo(): Promise<void> {

    }

    getPsoTotalPaxOverride(options: any): NullableNumber {
        return null;
    }

}